import "jquery-validation/dist/jquery.validate";
import getRecaptchaResponse from "./recaptcha";
import { ready } from "./helpers";
ready(() => {
  // load responses on init
  getRecaptchaResponse();

  // load responses again every 2 mins... then again after ajax calls
  setInterval(() => {
    getRecaptchaResponse();
  }, 2 * 60 * 1000);

  /**
   * Handle the forms
   * Using jquery validation for now, might change in future
   *
   * @param {Class with dot} formClass
   * @param {Ajax action to call} formAction
   * @param {Data layer form name for tag manager} dataLayerFormName
   * @param {Readable form name} readableFormName
   * */
  const formHandler = (
    formClass,
    formAction,
    dataLayerFormName,
    readableFormName
  ) => {
    const contactForm = document.querySelector(formClass);
    const jqContactForm = $(formClass);
    if (contactForm) {
      const contactFormSubmit = contactForm.querySelector(
        "button[type='submit']"
      );
      const contactFormSubmitOriginalHtml = contactFormSubmit.innerHTML;
      const contactFormAlert = contactForm.querySelector(
        ".success-error-message"
      );

      contactForm.addEventListener("submit", (e) => {
        e.preventDefault();

        jqContactForm.validate({
          errorPlacement: (er) => {
            er.hide();
          },
          highlight: (el) => {
            $(el).addClass("is-invalid").removeClass("is-valid");
          },
          unhighlight: (el) => {
            $(el).addClass("is-valid").removeClass("is-invalid");
          }
        });

        if (jqContactForm.valid()) {
          var formData = new FormData(contactForm);
          formData.append("action", formAction);
          formData.append("nonce", webroll_js_data.ajax_nonce);
          formData.append("readable_form_name", readableFormName);

          contactFormSubmit.disabled = true;
          contactFormSubmit.innerHTML =
            "Sending <i class='fas fa-spinner-third fa-spin'></i>";

          fetch(webroll_js_data.ajax_url, {
            method: "post",
            body: formData,
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin"
          })
            .then((response) => response.json())
            .then((data) => {
              contactFormSubmit.innerHTML = data.status;
              contactFormAlert.style.display = "block";
              contactFormAlert.innerHTML = data.message;
              data.status == "Success"
                ? contactFormAlert.classList.add(
                    "bg-success",
                    "text-white",
                    "p-3"
                  )
                : contactFormAlert.classList.add(
                    "bg-danger",
                    "text-white",
                    "p-3"
                  );
              // datalayer is throwing error in development. Add this only in prod
              if (typeof dataLayer !== "undefined") {
                dataLayer.push({
                  event: "wrFormSubmit",
                  formName: dataLayerFormName
                });
              }
              // reset the form data
              setTimeout(() => {
                contactForm.reset();
                contactFormSubmit.disabled = false;
                contactFormSubmit.innerHTML = contactFormSubmitOriginalHtml;
                contactFormAlert.style.display = "none";
                contactForm.querySelectorAll("input").forEach((i) => {
                  i.classList.remove("is-valid", "is-invalid");
                });
              }, 5000);
            })

            // reload the recaptcha inputs
            .then(() => getRecaptchaResponse())

            .catch((error) => {
              console.log(error);
              // console.log(error.name);
              // console.log(error.message);
              // console.log(error.stack);
            });
        }
      });
    }
  };
  formHandler(
    ".contact_form",
    "form_handler_callback",
    "contactForm",
    "Contact form"
  );
});
